import React, { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import ArticleEditor from '../../../components/editor/ArticleEditor';
import axiosPost from '../../../helpers/axios-helper';
import '../../dashboard/styles/Dashboard.css';

export default function SitePages() {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [editorData, setEditorData] = useState(null);

  useEffect(() => {
    loadPages();
  }, []);

  const loadPages = () => {
    setIsLoading(true);
    axiosPost(
      'site-pages/list',
      { 'Content-Type': 'application/json' },
      {},
      (resp) => {
        if (resp?.success) {
          setPages(resp.data || []);
        }
        setIsLoading(false);
      },
      (err) => {
        console.error('Failed to load site pages:', err);
        setIsLoading(false);
      }
    );
  };

  const handleEdit = (page) => {
    // Fetch full page with blocks
    axiosPost(
      'site-pages/get',
      { 'Content-Type': 'application/json' },
      { id: page.id },
      (resp) => {
        if (resp?.success && resp.data) {
          const full = resp.data;
          setEditorData({
            id: full.id,
            slug: full.slug,
            title: full.title || '',
            excerpt: full.excerpt || '',
            image: full.featured_image_url || '',
            category: 'Site Page',
            country_id: '',
            tags: [],
            blocks: full.blocks || [],
            date_published: full.created_at || Math.floor(Date.now() / 1000),
            status: full.status || 'draft'
          });
          setIsEditorOpen(true);
        }
      },
      (err) => console.error('Failed to load page:', err)
    );
  };

  const handleEditorSave = (data) => {
    const payload = {
      id: data.id,
      slug: editorData?.slug || '',
      title: data.title,
      excerpt: data.excerpt,
      image: data.image,
      status: data.status || 'published',
      blocks: data.blocks || []
    };

    axiosPost(
      'site-pages/update',
      { 'Content-Type': 'application/json' },
      payload,
      (resp) => {
        if (resp?.success) {
          setIsEditorOpen(false);
          setEditorData(null);
          loadPages();
        } else {
          console.error('Save failed:', resp?.response);
        }
      },
      (err) => console.error('Save error:', err)
    );
  };

  const handleEditorClose = () => {
    setIsEditorOpen(false);
    setEditorData(null);
  };

  if (isEditorOpen && editorData) {
    return (
      <ArticleEditor
        initialData={editorData}
        onSave={handleEditorSave}
        onClose={handleEditorClose}
        mode="site-page"
      />
    );
  }

  return (
    <div>
      <div className="DashboardPanel">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1 className="DashboardTitle">Site Pages</h1>
        </div>

        <p style={{ marginBottom: '20px', color: '#666' }}>
          Manage static pages like "Our Story", "About Us", etc. These pages use the article editor for rich content.
        </p>

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <table className="DashboardTable">
            <thead>
              <tr>
                <th>Title</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pages.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                    No site pages found. Run the SQL migration to create default pages.
                  </td>
                </tr>
              ) : (
                pages.map(page => (
                  <tr key={page.id}>
                    <td>{page.title}</td>
                    <td><code>/{page.slug}</code></td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        background: page.status === 'published' ? '#e8f5e9' : '#fff3e0',
                        color: page.status === 'published' ? '#2e7d32' : '#e65100'
                      }}>
                        {page.status}
                      </span>
                    </td>
                    <td>{page.updated_at ? new Date(page.updated_at * 1000).toLocaleDateString() : '-'}</td>
                    <td>
                      <button
                        onClick={() => handleEdit(page)}
                        style={{ background: 'none', cursor: 'pointer', marginRight: '10px' }}
                        title="Edit Page"
                      >
                        <FaEdit color="#1976d2" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
